import { metricsMapper } from './mappers';
export function toPulseMetric(metric, getHtmlElementMetadata) {
    return metricsMapper?.[metric.name](metric, getHtmlElementMetadata);
}
export function getHtmlElementMetadataWrapper(getHtmlElementMetadata) {
    return (node) => {
        let htmlElementMetadata = {
            compType: 'no-target-element',
        };
        if (node) {
            try {
                htmlElementMetadata = getHtmlElementMetadata(node);
            }
            catch (e) {
                htmlElementMetadata = {
                    compType: 'metadata-callback-error',
                };
            }
        }
        return htmlElementMetadata;
    };
}
//# sourceMappingURL=index.js.map